import axios from '@/api/axios';
import {toQueryString} from '@/api/queryString';
import type {
  AdminPaginatedEnvelope,
  AfriexQueryParams,
  BusinessCountry,
} from '@/types';

/**
 * The B2B country catalogue.
 *
 * A different collection from `countryService`'s: `business-country`, keyed on
 * `code` rather than `iso2`, with its whole editable surface under `meta`. It
 * lives under `/business` rather than beside `/v2/admin/countries` so that
 * boundary is visible in the URL.
 */
const commonEndpoint = '/v2/admin/business/countries';

export type BusinessCountryResponse = AdminPaginatedEnvelope<BusinessCountry[]>;

export const businessCountryService = {
  getList: async (
    filters: AfriexQueryParams,
  ): Promise<BusinessCountryResponse> => {
    const params = {
      page: 0,
      limit: 20,
      ...filters,
    };
    const url = `${commonEndpoint}?${toQueryString(params)}`;
    const response = await axios.get<BusinessCountryResponse>(url);
    return response.data;
  },

  getItem: async (countryCode: string): Promise<BusinessCountry> => {
    const response = await axios.get<BusinessCountry>(
      `${commonEndpoint}/${countryCode}`,
    );
    return response.data;
  },

  saveOne: async (
    itemId: string,
    body: Partial<BusinessCountry>,
  ): Promise<BusinessCountry> => {
    const response = await axios.patch<BusinessCountry>(
      `${commonEndpoint}/${itemId}`,
      body,
    );
    return response.data;
  },
};
